(function() {
  var translations = {
    "nl": { "Filter:": "Filter:", "Filter": "Filter", "Availability": "Beschikbaarheid", "Price": "Prijs", "In stock": "Op voorraad", "Out of stock": "Niet op voorraad", "From": "Van", "To": "Aan", "Clear all": "Wis alles", "Clear": "Wis", "Sort by:": "Sorteer op:" },
    "de": { "Filter:": "Filter:", "Filter": "Filter", "Availability": "Verfügbarkeit", "Price": "Preis", "In stock": "Auf Lager", "Out of stock": "Nicht auf Lager", "From": "Von", "To": "Bis", "Clear all": "Alle löschen", "Clear": "Löschen", "Sort by:": "Sortieren nach:" }
  };
  function getLocale() {
    var lang = (document.documentElement.lang || "").toLowerCase();
    if (lang.indexOf("nl") === 0) return "nl";
    if (lang.indexOf("de") === 0) return "de";
    return null;
  }
  function translateText(el, locale) {
    var map = translations[locale];
    if (!map) return;
    el.childNodes.forEach(function(n) {
      if (n.nodeType === Node.TEXT_NODE) {
        var t = n.nodeValue.trim();
        if (map[t]) n.nodeValue = n.nodeValue.replace(t, map[t]);
      }
    });
  }
  function applyTranslations() {
    var locale = getLocale();
    if (!locale) return;
    var selectors = [
      ".facets__heading",
      ".facets__summary",
      ".facets__summary > span",
      ".facets__summary span:first-child",
      ".facets__price label",
      ".facets__price .field__label",
      ".facets__heading-display",
      ".facets__filters-title",
      ".facets__filter-title",
      ".facets__form summary",
      ".facets__form > span",
      ".facets-vertical-form span",
      ".facets__display-by",
      ".facets__display label",
      ".active-facets__heading",
      ".facet-checkbox label",
      ".facet-checkbox span",
      ".facets-pill",
      ".sorting"
    ];
    selectors.forEach(function(sel) {
      document.querySelectorAll(sel).forEach(function(el) {
        translateText(el, locale);
      });
    });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applyTranslations);
  } else {
    applyTranslations();
  }
  var obs = new MutationObserver(function(mutations) {
    var run = false;
    mutations.forEach(function(m) {
      if (m.addedNodes && m.addedNodes.length) run = true;
    });
    if (run) applyTranslations();
  });
  if (document.body) {
    obs.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener("DOMContentLoaded", function() {
      obs.observe(document.body, { childList: true, subtree: true });
    });
  }
})();